import { useEffect, useState } from 'react';
import { getPublicSiteSettings } from '../services/siteContentService';

let cachedSettings = null;
let settingsPrefetch = null;

export const preloadPublicSiteSettings = () => {
  if (!settingsPrefetch) {
    settingsPrefetch = getPublicSiteSettings()
      .then((data) => {
        if (data && typeof data === 'object') {
          cachedSettings = data;
        }
        return data;
      })
      .catch(() => null);
  }
  return settingsPrefetch;
};

export const useSiteSettings = () => {
  const [settings, setSettings] = useState(cachedSettings || {});

  useEffect(() => {
    preloadPublicSiteSettings().then((data) => {
      if (data && typeof data === 'object') {
        setSettings(data);
      }
    });
  }, []);

  return settings;
};
